import { useCallback, useRef } from "react";

export const useScrollPagination = (
  hasMore: boolean,
  loadingMore: boolean,
  loadMore?: () => void,
) => {
  const observerRef = useRef<IntersectionObserver | null>(null);

  // Тип RefCallback<HTMLElement> подходит для любых тегов (a, div, li и т.д.)
  const lastItemRef = useCallback<React.RefCallback<HTMLElement>>(
    (node) => {
      if (!loadMore) return;
      if (loadingMore) return;
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && !loadingMore) {
          loadMore();
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [loadingMore, hasMore, loadMore],
  );

  return { lastItemRef };
};
